import React from 'react'
import Panel from '../Panel'
import { dGet } from '@core/utils'
import LabelText from '../LabelText'
import isEmpty from 'lodash/isEmpty'
import Upload from '../../Upload'

const ContactCard = ({ item, operator }) => {
  const { remark, attachments } = dGet(item, 'contact_card', {})

  return (
    <Panel
      icon="//qnm.hunliji.com/o_1d8n859qu16up1qedrrc176eidno.png"
      item={item}
    >
      <LabelText block>{remark}</LabelText>

      {!isEmpty(attachments) && (
        <Upload showUpload={false} value={attachments} />
      )}

      <LabelText label="操作人">{operator}</LabelText>
    </Panel>
  )
}

export default ContactCard
